module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.requirements,
      "multiple": true,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "max": 20,
      "placeholder": "Link requirements to content",
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38cde03a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/confluence/ConfluenceInsertRequirementsMacroEditorView.vue
// module id = 1007
// module chunks = 1